import { jsx as _jsx } from "react/jsx-runtime";
import { ImageIcon } from "../../../../icons/ImageIcon";
import { ImageMenu } from "./ImageMenu";
export const imageToolbarControl = {
    name: "image",
    icon: _jsx(ImageIcon, { "aria-hidden": "true" }),
    options: {
        upload: true,
        url: true,
        browse: false
    },
    popover: ({ options, ...props }) => _jsx(ImageMenu, { options: options, ...props })
};
